import './App.css';
import Services from './pages/Services';

function App() {

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <nav className="nav">
          <div className="logo">Jazmine Smith</div>
          <ul className="nav-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#skills">Skills</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content">
          <h1>Jazmine Smith</h1>
          <h2>Full-Stack Software Engineer</h2>
          <p>Technical Solutions & Client Engagement</p>
          <div className="contact-info">
            <p>
              <a href="mailto:jazminetsmith@gmail.com">jazminetsmith@gmail.com</a> |
              <a href="https://www.linkedin.com/in/jazminetsmith/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="https://github.com/Jazsmith24" target="_blank" rel="noopener noreferrer">GitHub</a>
            </p>
          </div>
        </div>
      </section >

      {/* About Section */}
      < section id="about" className="about" >
        <div className="container">
          <h2>Professional Summary</h2>
          <p className="summary">
            Full-Stack Software Engineer with 5+ years of experience building accessible, user-focused web applications.
            Combines deep technical expertise in modern JavaScript frameworks and CMS platforms with proven skills in teaching,
            public speaking, and performance. Passionate about leveraging technology to solve problems, engage communities,
            and translate complex concepts into compelling narratives.
          </p>

          <div className="education">
            <h3>Education</h3>
            <div className="education-item">
              <h4>Operation Spark</h4>
              <p>Software Engineering | Aug 2019 - Nov 2020</p>
              <p>Fundamentals of JavaScript, Functional Programming, Web Development/Design, UX/UI Design, Schema Design</p>
            </div>
          </div>
        </div>
      </section >

      <Services />


      {/* Experience Section */}
      <section id="experience" className="experience">
        <div className="container">
          <h2>Professional Experience</h2>

          <div className="experience-item current-role">
            <div className="experience-header">
              <div className="current-badge">Current Role</div>
              <h3>Tulane University - School of Architecture</h3>
              <a href="architecture.tulane.edu" target="_blank" rel="noopener noreferrer">architecture.tulane.edu</a>
              <h4>Web Engineer | April 2022 - Present | New Orleans, LA</h4>
            </div>
            <div className="experience-content">
              <p className="role-description">
                As the lead technical engineer for the School of Architecture's digital ecosystem, I balance innovative
                web solutions with robust, maintainable systems that serve diverse stakeholders including administration,
                faculty, students, and prospective candidates.
              </p>
              <div className="achievements">
                <h5>Key Responsibilities & Achievements:</h5>
                <ul>
                  <li>
                    <strong>Architect and maintain</strong> a responsive, WCAG 2.1 compliant website using Drupal and WordPress,
                    serving 2,000+ daily users with 99.9% uptime while continuously improving page load performance
                  </li>
                  <li>
                    <strong>Lead end-to-end development</strong> of faculty/staff intranet portal, implementing Agile methodologies
                    to deliver features 25% faster than previous development cycles
                  </li>
                  <li>
                    <strong>Pioneer custom Gutenberg blocks</strong> and backend modules that reduce content management time by 60%
                    for non-technical staff, enabling faster publication of academic content and event promotions
                  </li>
                  <li>
                    <strong>Modernize development workflow</strong> by containerizing environments with Docker and implementing
                    Pantheon for version control, reducing deployment conflicts by 75% and improving team collaboration
                  </li>
                  <li>
                    <strong>Translate complex stakeholder requirements</strong> into technical specifications, serving as primary
                    technical liaison between administration, faculty, and development teams to ensure alignment with institutional goals
                  </li>
                  <li>
                    <strong>Manage vendor relationships</strong> and outsourced developer resources, optimizing support coverage
                    while reducing external dependency costs through strategic resource allocation
                  </li>
                </ul>
              </div>
              <div className="technologies">
                <strong>Technologies:</strong> Drupal, WordPress, PHP, JavaScript, React, Docker, Pantheon, Git, AWS, REST APIs, WCAG 2.1
              </div>
            </div>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>Operation Spark</h3>
              <h4>Teaching Assistant & Technical Mentor | January 2021 - April 2022 | New Orleans, LA</h4>
            </div>
            <div className="experience-content">
              <p className="role-description">
                Technical educator and mentor in an intensive software engineering bootcamp, guiding students through
                full-stack JavaScript development while fostering problem-solving skills and professional growth.
              </p>
              <div className="achievements">
                <h5>Key Contributions:</h5>
                <ul>
                  <li>
                    <strong>Mentored 100+ students</strong> through software engineering fundamentals, providing personalized
                    guidance that resulted in a 95% course completion rate and 85% job placement within 6 months of graduation
                  </li>
                  <li>
                    <strong>Developed and demonstrated</strong> solutions for complex algorithmic challenges and full-stack
                    projects, breaking down advanced concepts into digestible components for diverse learning styles
                  </li>
                  <li>
                    <strong>Provided critical technical support</strong> during live coding sessions and project work,
                    reducing student blockers by 70% and increasing overall cohort satisfaction scores by 35%
                  </li>
                  <li>
                    <strong>Collaborated with instructional team</strong> to refine curriculum materials and assessment
                    methods, contributing to a 25% improvement in student comprehension metrics
                  </li>
                </ul>
              </div>
              <div className="technologies">
                <strong>Technologies:</strong> JavaScript, Node.js, React, PostgreSQL, Git, Algorithms, Data Structures, Debugging
              </div>
            </div>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>French Quarter Festival</h3>
              <a href="https://frenchquarterfest.org/fest-a" target="_blank" rel="noopener noreferrer">frenchquarterfest.org/fest-a</a>
              <h4>Full-Stack Software Engineer | January 2022 - April 2022 | New Orleans, LA</h4>
            </div>
            <div className="experience-content">
              <p className="role-description">
                Mobile application developer for one of New Orleans' largest music festivals, creating engaging digital
                experiences for 80,000+ attendees while modernizing legacy codebase and improving application performance.
              </p>
              <div className="achievements">
                <h5>Key Deliverables:</h5>
                <ul>
                  <li>
                    <strong>Engineered cross-platform mobile application</strong> using Ionic and Angular that served
                    15,000+ active users during the festival, with 4.8-star average rating across app stores
                  </li>
                  <li>
                    <strong>Architected dynamic vendor menu system</strong> by integrating with RESTful APIs, enabling
                    real-time updates of food, merchandise, and schedule information that reduced user confusion by 60%
                  </li>
                  <li>
                    <strong>Increased user engagement</strong> by 45% through refactoring core features including
                    favorites system and personalized schedule builder, implementing local storage for seamless offline experience
                  </li>
                  <li>
                    <strong>Modernized legacy codebase</strong> by refactoring JavaScript components, resulting in
                    50% faster load times, 40% reduction in memory usage, and improved code maintainability for future developers
                  </li>
                </ul>
              </div>
              <div className="technologies">
                <strong>Technologies:</strong> Ionic, Angular, TypeScript, Cordova, REST APIs, Local Storage, JavaScript, Git, Agile
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section id="skills" className="skills">
        <div className="container">
          <h2>Technical Skills</h2>
          <div className="skills-grid">
            <div className="skill-category">
              <h3>Languages & Technologies</h3>
              <p>Advanced expertise in HTML5, CSS3/SASS, JavaScript (ES6+), TypeScript, PHP, and SQL for full-stack development and scalable application architecture.</p>
            </div>
            <div className="skill-category">
              <h3>Frameworks & Libraries</h3>
              <p>Production experience with React, Angular, Next.js, Ionic, Node.js, and Express for building performant, maintainable applications across platforms.</p>
            </div>
            <div className="skill-category">
              <h3>Platforms & CMS</h3>
              <p>Specialized in WordPress (Gutenberg, custom themes/plugins), Drupal, and headless CMS solutions for flexible, content-driven digital experiences.</p>
            </div>
            <div className="skill-category">
              <h3>Tools & Engineering Practices</h3>
              <p>Proficient with Git/GitLab, Docker, AWS, Technical SEO, WCAG 2.1 accessibility, Lighthouse optimization, and Agile/Scrum project management.</p>
            </div>
            <div className="skill-category">
              <h3>Professional Skills</h3>
              <p>Expert communicator with strengths in public speaking, technical training, client relations, team collaboration, and creative problem-solving.</p>
            </div>
          </div>
        </div>
      </section>



      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2>Get In Touch</h2>
          <p>Ready to collaborate or discuss opportunities? Reach out to me!</p>

          <div className="contact-info">
            <div className="contact-item">
              <strong>Email:</strong>
              <a href="mailto:jazminetsmith@gmail.com">jazminetsmith@gmail.com</a>
            </div>

            <div className="contact-item">
              <strong>Location:</strong>
              <span>New Orleans, LA</span>
            </div>
            <div className="contact-item">
              <strong>LinkedIn:</strong>
              <a href="https://www.linkedin.com/in/jazminetsmith/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
            <div className="contact-item">
              <strong>GitHub:</strong>
              <a href="https://github.com/Jazsmith24" target="_blank" rel="noopener noreferrer">github.com/Jazsmith24</a>            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 Jazmine Smith. All rights reserved.</p>
        </div>
      </footer>
    </div >
  );
}

export default App;